/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Start_Trial_ButtonInputs */

const en_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start trial`)
};

const id_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulai uji coba`)
};

const ms_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mulakan percubaan`)
};

const ca_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar prova`)
};

const cs_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zahájit zkušební verzi`)
};

const da_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begynd prøveversion`)
};

const de_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testversion starten`)
};

const et_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alusta prooviperioodi`)
};

const es_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empezar prueba`)
};

const fr_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer l’essai`)
};

const hr_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Započnite probno razdoblje`)
};

const it_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia la prova gratuita`)
};

const lv_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sākt izmēģinājuma periodu`)
};

const lt_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pradėti bandomąjį laikotarpį`)
};

const hu_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Próbaidőszak indítása`)
};

const nl_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proefperiode starten`)
};

const nb_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start prøveperiode`)
};

const pl_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozpocznij okres próbny`)
};

const pt_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar o teste`)
};

const ro_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Începe perioada de probă`)
};

const sk_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začať skúšobnú verziu`)
};

const sl_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začni preizkus`)
};

const fi_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita kokeilu`)
};

const sv_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starta provperiod`)
};

const vi_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt đầu dùng thử`)
};

const tr_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Denemeyi başlat`)
};

const el_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έναρξη δοκιμαστικής περιόδου`)
};

const bg_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Започни пробния период`)
};

const ru_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать пробный период`)
};

const sr_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Започни пробу`)
};

const uk_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Розпочати пробний період`)
};

const ka_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`საცდელი პერიოდის დაწყება`)
};

const hi_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ट्रायल शुरू करें`)
};

const th_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เริ่มทดลองใช้`)
};

const ko_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`평가판 시작`)
};

const zh_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始试用`)
};

const zh_tw_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始試用`)
};

const ja_start_trial_button = /** @type {(inputs: Start_Trial_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアルを開始`)
};

/**
* | output |
* | --- |
* | "Start trial" |
*
* @param {Start_Trial_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const start_trial_button = /** @type {((inputs?: Start_Trial_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Start_Trial_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_start_trial_button(inputs)
	if (locale === "ms") return ms_start_trial_button(inputs)
	if (locale === "ca") return ca_start_trial_button(inputs)
	if (locale === "cs") return cs_start_trial_button(inputs)
	if (locale === "da") return da_start_trial_button(inputs)
	if (locale === "de") return de_start_trial_button(inputs)
	if (locale === "et") return et_start_trial_button(inputs)
	if (locale === "es") return es_start_trial_button(inputs)
	if (locale === "fr") return fr_start_trial_button(inputs)
	if (locale === "hr") return hr_start_trial_button(inputs)
	if (locale === "it") return it_start_trial_button(inputs)
	if (locale === "lv") return lv_start_trial_button(inputs)
	if (locale === "lt") return lt_start_trial_button(inputs)
	if (locale === "hu") return hu_start_trial_button(inputs)
	if (locale === "nl") return nl_start_trial_button(inputs)
	if (locale === "nb") return nb_start_trial_button(inputs)
	if (locale === "pl") return pl_start_trial_button(inputs)
	if (locale === "pt") return pt_start_trial_button(inputs)
	if (locale === "ro") return ro_start_trial_button(inputs)
	if (locale === "sk") return sk_start_trial_button(inputs)
	if (locale === "sl") return sl_start_trial_button(inputs)
	if (locale === "fi") return fi_start_trial_button(inputs)
	if (locale === "sv") return sv_start_trial_button(inputs)
	if (locale === "vi") return vi_start_trial_button(inputs)
	if (locale === "tr") return tr_start_trial_button(inputs)
	if (locale === "el") return el_start_trial_button(inputs)
	if (locale === "bg") return bg_start_trial_button(inputs)
	if (locale === "ru") return ru_start_trial_button(inputs)
	if (locale === "sr") return sr_start_trial_button(inputs)
	if (locale === "uk") return uk_start_trial_button(inputs)
	if (locale === "ka") return ka_start_trial_button(inputs)
	if (locale === "hi") return hi_start_trial_button(inputs)
	if (locale === "th") return th_start_trial_button(inputs)
	if (locale === "ko") return ko_start_trial_button(inputs)
	if (locale === "zh") return zh_start_trial_button(inputs)
	if (locale === "zh-tw") return zh_tw_start_trial_button(inputs)
	if (locale === "ja") return ja_start_trial_button(inputs)
	return en_start_trial_button(inputs)
});